// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"318":"60862772","624":"4cd2e27f","779":"0f285d41","946":"8cbd06ae","958":"56ce2c54"}[chunkId] + ".css";
};